module.exports = __webpack_public_path__ + "img/book_04.39793ab4.jpg";